import {
  LEDModes,
  MachinePublicHydrated,
} from "@aura-frontend/omnibus-az-client";

import {
  LedModesLabels,
  STANDBY_LABEL,
} from "@/components/EventForm/EventLEDBoardConfiguration/ledModes";
import { isPopulatedArray } from "@/pages/Tagging/utils/array";

/**
 * Infer the currently-committed LED mode from a machine's active entitlement
 * arrays. Order of precedence (blocked > umpire > stat > none) matches how the
 * old Automation modal interpreted state and how the four-option radio
 * collapses combinations into a single selection.
 */
export function committedModeFor(
  m: Pick<
    MachinePublicHydrated,
    "smartBlockedActive" | "umpireAssistActive" | "smartAvailableActive"
  >,
): LEDModes | null {
  if (isPopulatedArray(m.smartBlockedActive)) return "blocked";
  if (isPopulatedArray(m.umpireAssistActive)) return "umpire_assist";
  if (isPopulatedArray(m.smartAvailableActive)) return "stat_tracking";
  return null;
}

/**
 * User-facing label for any LED mode, including the `null` (no entitlements)
 * state which `LedModesLabels` cannot express on its own.
 */
export function labelForLedMode(mode: LEDModes | null): string {
  return mode === null ? STANDBY_LABEL : LedModesLabels[mode];
}
